import './sass/main.scss';
import './js/change-theme';
import './js/fetch-api';
import './js/navigation';
import './js/loader';
import './js/logo-anime';
import './js/dev-modal';
import './js/pagination';
import './js/btn-up';
import './js/home';
import './js/open-moviecard';
import './js/render-library';
import './js/registration';
import './js/trailer';
import './js/find-for-genre';
